import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Int" }
const _hoisted_2 = { class: "App-Int-Top" }
const _hoisted_3 = {
  style: {"margin-left":"10px"},
  "mute-secondary": ""
}
const _hoisted_4 = { "mute-secondary": "" }
const _hoisted_5 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_app_over_avatars = _resolveComponent("app-over-avatars")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_space, {
        "w-100": "",
        alignment: "center",
        size: 12
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_app_over_avatars, { size: 50 }, {
              one: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  src: _ctx.interest.createdBy.avatar,
                  icon: "el-icon-user-solid",
                  size: 45
                }, null, 8, ["src"])
              ]),
              two: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  src: _ctx.interest.business.avatar,
                  icon: "el-icon-user-solid",
                  size: 45
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_space, {
            justify: "space-between",
            "w-100": "",
            size: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.interest.business.name), 1),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.interest.business.industry) + " industry " + _toDisplayString(_ctx.interest.business.stage) + " stage ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$moment(_ctx.interest.createdAt).fromNow()), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.interest.talents) + " " + _toDisplayString(_ctx.interest.skill[1]) + " " + _toDisplayString(_ctx.$filters.capitalize(_ctx.decideTalentWording())) + " Needed to " + _toDisplayString(_ctx.interest.outcome), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_app_truncate, {
          content: _ctx.interest.description,
          max: 250,
          onViewMore: _ctx.clickedMore,
          "m-tb-0": ""
        }, null, 8, ["content", "onViewMore"])
      ]),
      _createVNode(_component_el_space, {
        size: 16,
        wrap: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tag, {
            "tag-default": "",
            "is-all-borderless": "",
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.interest.compensation.join(", "))), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tag, {
            "tag-default": "",
            "is-all-borderless": "",
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.interest.wow)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, [
            _cache[0] || (_cache[0] = _createTextVNode("From ", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$moment(_ctx.interest.startDate).format("D MMM yy")), 1)
          ]),
          _createElementVNode("span", null, [
            _cache[1] || (_cache[1] = _createTextVNode("To ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$moment(_ctx.interest.endDate).format("D MMM yy")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_row, {
      align: "center",
      justify: "space-between",
      "w-100": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_link, { type: "primary" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Read More", -1)
            ]))]),
            _: 1
          })
        ]),
        _createVNode(_component_el_button, {
          "is-borderless": "",
          icon: "el-icon-share"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Share", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}